module.exports = __webpack_public_path__ + "img/2.785cfa57.jpeg";